export default "__VITE_ASSET__D$o1sBMA__"